module.exports = __webpack_public_path__ + "media/images/logo-9d09c9c561c9004953a7229d6498332a.png";